import { useMutation } from "@tanstack/react-query";
import api from "../../utils/axiosInstance";
import { useSnackbar } from "notistack";

// Service function for signup API call
export const signupAPI = async ({ username, email, password }) => {
  const response = await api.post("/signup/", { username, email, password });
  return response.data;
};

export const useSignupService = () => {
  const { enqueueSnackbar } = useSnackbar();

  const { mutate, isLoading, isSuccess, data, error, isError } = useMutation({
    mutationFn: signupAPI,
    onSuccess: (data) => {
      enqueueSnackbar(data.message || "Account created successfully!", { variant: "success" });
    },
    onError: (error) => {
      if (error?.response?.data) {
        const errMsg =
          error.response.data.detail ||
          Object.values(error.response.data).flat().join(" ") ||
          "Signup failed";
        enqueueSnackbar(errMsg, { variant: "error" });
      } else {
        enqueueSnackbar("Signup failed", { variant: "error" });
      }
    },
  });

  return {
    signup: mutate,
    isLoading,
    isSuccess,
    data,
    error,
    isError,
  };
};